module.exports = __webpack_public_path__ + "img/mj8-cooling.75d776f8.png";